import { useEffect, useRef, useState } from 'react'

// A batch name field that holds the default name as its text, not as a hint, so
// nobody has to type a name to start. `name` is the user's own name ('' while the
// default is used): the text follows the default (a workflow change) until the user
// edits it, and an emptied field goes back to the default when it loses focus.
// Typing the default itself counts as using the default.
const useNameWithDefault = (name, defaultName, onNameChange) => {
  const [text, setText] = useState(name || defaultName)
  const focusedRef = useRef(false)

  // A new default, or a name set from outside (a draft, a suggestion), shows unless
  // the user is typing.
  useEffect(() => {
    if (!focusedRef.current) setText(name || defaultName)
  }, [name, defaultName])

  return {
    value: text,
    onChange: (event) => {
      const next = event.target.value
      setText(next)
      onNameChange(next.trim() === defaultName ? '' : next)
    },
    onFocus: () => {
      focusedRef.current = true
    },
    onBlur: () => {
      focusedRef.current = false
      if (!text.trim()) setText(name || defaultName)
    },
  }
}

export default useNameWithDefault
